export default __webpack_public_path__ + "static/media/zahnraeder.8d9f56be.svg";